import Cliente from '../Models/Cliente';

const CheckoutContext = {
    //TODO: importar todo el contexto desde un archivo externo
    skipPersonalDataForm: false,
    showToastErrorWondersoft: false,
    correlationId: null,
    agregarDomicilio: false,
    canalDeVenta: null,
    campaniasBonificadasActivas: [410],
    campaniasActivas: [409, 959],
    campaniaId: null, 
    combo: null,
    comboBonificado: 111,
    dataDomicilio: {},
    dataObtenerMontoService: '',
    dataVenta: null,
    datosCarrito: {
        nombrePlan: '',
        montoTotal: '',
        mesActual: '',
        mesSiguiente: '',
        montoProporcional: '',
        montoMesSiguiente: '',
        mesesDescuento: '',
        montoFinal: '',
        urlRef: '',
    },
    datosPersonales: { ...Cliente },
    domicilio: [...Cliente.domicilios],
    enabledDomicilio: false,
    error: null,
    erroresDatosPersonales: null,
    errorMessage: null,
    formaDeContacto: null,
    isBonusSale: null,
    isLoading: true,
    modo: '',
    planBeneficios: null,
    planCampania: null,
    showCart: null,
    showToastPersonalData: null,
    showToastDniInvalido: null,
    usuarioPrecargado: false,
    productCategory : null
};

export default CheckoutContext;
